<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-交易设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">余额积分设置</div>

      <el-form-item label="文字">
        <el-input v-model="form.balance_text" type="text" style="width: 200px;">
          <template slot="prepend">余额=</template>
        </el-input>
        <!-- <el-input v-model="form.point_text" type="text" style="width: 200px;">
           <template slot="prepend">积分=</template>
        </el-input> -->

      </el-form-item>


      <div class="common-form">订单流程设置</div>
      <el-form-item label="未支付订单">
        <el-input v-model="form.close_days" type="number" style="width: 200px;"></el-input>
        分钟后自动关闭
        <div class="tips">
          订单下单未付款，n分钟后自动关闭，设置0不自动关闭
        </div>
      </el-form-item>
      <el-form-item label="已发货订单">
        <el-input v-model="form.receive_days" type="number" style="width: 200px;"></el-input>
        天后自动确认收货
        <div class="tips">
          如果在期间未确认收货，系统自动完成收货，设置0天不自动收货
        </div>
      </el-form-item>
      <el-form-item label="已完成订单">
        <el-input v-model="form.refund_days" type="number" style="width: 200px;"></el-input>
        天内允许申请售后
        <div class="tips">
          订单完成后 ，用户在n天内可以发起售后申请，设置0天不允许申请售后
        </div>
      </el-form-item>


      <div class="common-form">运费设置</div>
      <el-form-item label="运费组合策略">
        <div>
          <el-radio v-model="form.freight_rule" :label="10">叠加</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，将每个商品的运费之和订为订单总运费
          </div>

        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freight_rule" :label="20">已低运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最少的商品的运费计为订单总运费
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freight_rule" :label="30">已高运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最多的商品的运费计为订单总运费
          </div>
        </div>
      </el-form-item>
      <div class="common-form">商品价格设置</div>
      <el-form-item label="定价模式">
        <el-radio-group v-model="form.price_mode">
          <el-radio :label="0">系统默认</el-radio>
          <el-radio :label="20">自动级差</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="common-form">购买设置</div>
      <el-form-item label="是否开启购买权限">
        <el-radio-group v-model="form.buy_auth.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="20">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="允许查看价格的用户等级">
        <el-select v-model="form.buy_auth.show_price_id" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="允许购买的用户等级">
        <el-select v-model="form.buy_auth.buy_auth_id" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="无权限提示文字">
        <el-input v-model="form.buy_auth.tips" placeholder="提示文字" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="无权限是否显示价格">
        <el-radio-group v-model="form.buy_auth.no_price">
          <el-radio :label="0">显示</el-radio>
          <el-radio :label="1">不显示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="购买无权限时跳转链接">
        <el-input v-model="form.buy_auth.name" class="max-w460"></el-input>
        <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
      </el-form-item>

      <el-form-item label="开启浏览商品记录">
        <el-radio-group v-model="form.open_view_product">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
       <el-form-item label="下单提示">
        <el-input v-model="form.confirm_tips" placeholder="提示文字" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Setlink from '@/components/setlink/Setlink';
  export default {
    components: {
          Setlink,
      },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          close_days: '',
          receive_days: '',
          refund_days: '',
          freight_rule: '',
          price_mode: '',
          buy_auth:{
            is_open:0,
            show_price_id:[],
            buy_auth_id:[],
            no_price:0,
            tips:'无权限购买',
            name:'跳转连接',
            linkUrl:''
          },
          confirm_tips:'',
          balance_text:'',
          open_view_product:0
        },
        grade_list:[],
        loading: false,
        /*是否选择链接*/
          is_linkset: false,
          index: null,

      };
    },
    created() {
      this.getParams()
    },

    methods: {

      getParams() {
        let self = this;
        SettingApi.tradeDetail({}, true)
          .then(data => {
            if (data.code == 1) {
              let vars = data.data.vars.values;
              self.form.close_days = vars.order.close_days;
              self.form.receive_days = vars.order.receive_days;
              self.form.refund_days = vars.order.refund_days;
              self.form.freight_rule = vars.freight_rule;
              self.form.price_mode = vars.price_mode;
              self.form.buy_auth = vars.buy_auth;
              self.form.buy_auth.tips = vars.buy_auth.tips;
              self.form.buy_auth.linkUrl = vars.buy_auth.linkUrl;
              self.form.buy_auth.name = vars.buy_auth.name;
              self.form.buy_auth.is_open = vars.buy_auth.is_open;
              self.form.buy_auth.show_price_id = vars.buy_auth.show_price_id;
              self.form.buy_auth.buy_auth_id = vars.buy_auth.buy_auth_id;
              self.grade_list = data.data.grade_list;
              self.form.balance_text = vars.balance_text;
              self.form.open_view_product = vars.open_view_product;
              self.form.confirm_tips = vars.confirm_tips;
            }
          })
          .catch(error => {

          });

      },
      //监听复选框选中
      handleCheckedCitiesChange(val) {},
      onSubmit() {
        let self = this;
        self.loading = true;
        let form = self.form;
        SettingApi.editTrade(form, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，交易设置成功',
              type: 'success'
            });
            self.$router.push('/setting/trade/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

      /*获取链接并关闭弹窗*/
        closeLinkset(e) {
          this.is_linkset = false
          if (e) {
            this.form.buy_auth.linkUrl = e.url
            this.form.buy_auth.name = '链接到' + ' ' + e.type + ' ' + e.name
            if(e.appid) {
              this.form.buy_auth.appid = e.appid
            }
          }
        },


    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/trade/index.vue